'use strict';
        var _ = require('../dependency')._,
        config = require('../config'),
        $u = require('../utilities');
        var GRAPHS = config.graphs,
        $d = config.druid;


var chartId = 'DATA_BY_CUSTOMERS',
        chartType = 'TREND',
        filters = [config.filters.DURATION],
        dataRotateMapping = [{
                name: 'Public Data',
                field: 'amcApTrafficOverGuestSsidInKbs'
            },{
                name: 'Private Data',
                field: 'amcApTrafficOverNonGuestSsidInKbs'
            },{
                name: 'Private Data Download',
                field: 'amcApDownloadOverNonGuestSsidInKbs'
            }, {
                name: 'Private Data Upload',
                field: 'amcApUploadOverNonGuestSsidInKbs'
            }, {
                name: 'Public Data Download',
                field: 'amcApDownloadOverGuestSsidInKbs'
            }, {
                name: 'Public Data Upload',
                field: 'amcApUploadOverGuestSsidInKbs'
            }],
        dataSeries = {
            TIMESTAMP: 'timestamp',
            PRIVATE_DATA: 'amcApTrafficOverNonGuestSsidInKbs',
            GUEST_DATA: 'amcApTrafficOverGuestSsidInKbs',
            PRIVATE_DATA_DOWNLOAD: 'amcApDownloadOverNonGuestSsidInKbs',
            PRIVATE_DATA_UPLOAD: 'amcApUploadOverNonGuestSsidInKbs',
            GUEST_DATA_DOWNLOAD: 'amcApDownloadOverGuestSsidInKbs',
            GUEST_DATA_UPLOAD: 'amcApUploadOverGuestSsidInKbs'
        },
fieldNames = {
    PRIVATE_DATA: 'amcApTrafficOverNonGuestSsidInKbs',
    GUEST_DATA: 'amcApTrafficOverGuestSsidInKbs',
    PRIVATE_DATA_DOWNLOAD: 'amcApDownloadOverNonGuestSsidInKbs',
    PRIVATE_DATA_UPLOAD: 'amcApUploadOverNonGuestSsidInKbs',
    GUEST_DATA_DOWNLOAD: 'amcApDownloadOverGuestSsidInKbs',
    GUEST_DATA_UPLOAD: 'amcApUploadOverGuestSsidInKbs'
},
/**
 * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
 * can be modified for other data provider systems.]
 * @type {Object}
 */
dataConfig = [{
        queryType: 'groupBy',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        dimensions: ['customer'],
        granularityOverride: GRAPHS.GLOBAL.GRANULARITY_ALL,
        aggregations: [{
                type: 'longSum',
                name: dataSeries.GUEST_DATA,
                fieldName: fieldNames.GUEST_DATA
            }, {
                type: 'longSum',
                name: dataSeries.PRIVATE_DATA,
                fieldName: fieldNames.PRIVATE_DATA
            }, {
                type: 'longSum',
                name: dataSeries.PRIVATE_DATA_DOWNLOAD,
                fieldName: fieldNames.PRIVATE_DATA_DOWNLOAD
            }, {
                type: 'longSum',
                name: dataSeries.PRIVATE_DATA_UPLOAD,
                fieldName: fieldNames.PRIVATE_DATA_UPLOAD
            }, {
                type: 'longSum',
                name: dataSeries.GUEST_DATA_DOWNLOAD,
                fieldName: fieldNames.GUEST_DATA_DOWNLOAD
            }, {
                type: 'longSum',
                name: dataSeries.GUEST_DATA_UPLOAD,
                fieldName: fieldNames.GUEST_DATA_UPLOAD
            }]
    }],
        dataSeriesFields = ['dataType', 'dataSize'],
        modelFieldKeys = $u.charts.generateFieldKeysArray(dataConfig, dataSeriesFields),
        aggregationFields = _.chain(dataSeries).values().without(dataSeries.TIMESTAMP).value(),
        tasks = [
            'durationFilter',
            'druidQueryGenerator',
            'druidQueryValidator',
            'fetchChartData',
            'druidResponseParser', {
                name: 'afterApiAggregation',
                config: {
                    aggregationFields: aggregationFields
                }
            }, {
                plugin: modifyResponse
            }, {
                name: 'updateChartModelData',
                config: {
                    dataSeriesFields: dataSeriesFields,
                    modelFieldKeys: modelFieldKeys
                }
            }
        ];



exports.chartId = chartId;
exports.chartType = chartType;
exports.dataSeries = dataSeries;
exports.fieldNames = fieldNames;
exports.filters = filters;
exports.dataConfig = dataConfig;
exports.dataSeriesFields = dataSeriesFields;
exports.modelFieldKeys = modelFieldKeys;
exports.tasks = tasks;
exports.chartTemplate = chartTemplate;
exports.i18n = config.graphs.CHART_METADATA.DATA_BY_CUSTOMERS;



function modifyResponse(context, config, next) {
    var model = context.apiMergedResponse,
            computedModel = {},
            dataType,
            dataSize;
    _.forEach(dataRotateMapping, function (singlePluginMapping) {
        dataType = singlePluginMapping.name;
        dataSize = singlePluginMapping.field;
    
        if (!computedModel.dataType) {
            computedModel.dataType = [];
        }
        computedModel.dataType.push(dataType);

        if (!computedModel.dataSize) {
            computedModel.dataSize = [];
        }
        if (model[dataSize]) {
            computedModel.dataSize.push(model[dataSize]);
        } else {
            computedModel.dataSize.push(0);
        }


        delete model[dataType];
    });
    

    if ($u.charts.allEqualElemArray(computedModel.dataSize, 0) ||
            $u.charts.allEqualElemArray(computedModel.dataSize, null)
            ) {
        context.zeroDataFlag = true;
    }

    context.chartData = computedModel;
    next();
}


function chartTemplate(data, width) {
    /*!ToDo chech y width is a string in px*/
    width = parseInt(width.match(/\d+/g)[0], 10);

    var duration = data.__duration,
            xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
            x = xAxisLabelOffset.x,
            y = xAxisLabelOffset.y,
            legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false),
            pointWidth = width / 50;

    var yAxisBaseUnit = 'KB',
            yAxisRoundOff = false,
            yAxisFormatter = $u.charts.chartYaxisFormatter,
            yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            customDateString: data.__generationDateString,
            duration: duration,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            xAxisDataHeader: 'Data Type',
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces
        },
        chart: {
            type: 'column',
            zoomType: 'x,y',
            alignTicks: false,
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function () {
                    var dataUnit,
                            chartContext = this,
                            dataArray;

                    _.forEach(chartContext.yAxis, function (yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function (seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), 'KB').unit;
                        yAxisObject.setTitle({
                            text: GRAPHS.CHART_METADATA.DATA_BY_CUSTOMERS.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                var that = this,
                        tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit,
                                yAxisRoundOff, yAxisTrimDecimalPlaces);
                return $u.charts.sformat('{0}: {1} {2}',
                        that.x,
                        tooltipUnitObj.value,
                        tooltipUnitObj.unit
                        );
            },
            percentageDecimals: 0
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        xAxis: {
            categories: data.dataType,
            tickmarkPlacement: 'on',
            labels: {
                rotation: -45,
                align: 'center',
                x: x,
                y: y + 20,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function () {
                    return this.value;
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
                title: {
                    text: '',
                    style: {
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                        color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                    }
                },
                allowDecimals: false,
                min: 0,
                maxPadding: 0,
                lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
                lineWidth: 1,
                labels: {
                    format: '{value}',
                    formatter: function () {
                        var that = this,
                                yAxisValue = that.value,
                                yMaxValue = that.axis.dataMax;
                        return yAxisFormatter(yAxisValue, yMaxValue,
                                yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value;
                    },
                    style: {
                        fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                        fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                    },
                    x: -20
                }
            }],
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: false,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_OFF_WHITE
                }
            },
            series: {
                pointWidth: pointWidth
            }
        },
        series: [{
                showInLegend: false,
                name: 'Data Size',
                data: data.dataSize,
                color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
                borderColor: GRAPHS.GLOBAL.COLORS.MOJO_BLUE
            }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
